import type { GetStaticPropsContext } from 'next';

import { INDEX_MAP } from '#/lib/algolia';
import { fetchResourceCategoryPaths } from '#/lib/sanity/fetchers/fetchResourceCategoryPaths';
import {
  fetchResourceCategoryProps,
  type ResourceCategoryProps,
} from '#/lib/sanity/fetchers/fetchResourceCategoryProps';
import { Headline } from '#/components/Headline';
import { ListingFilters } from '#/components/ListingFilters';
import { ResourceHit } from '#/components/ResourceHit';
import { SearchableListing } from '#/components/SearchableListing';

export const config = {
  maxDuration: 30,
};

export async function getStaticPaths() {
  const paths = await fetchResourceCategoryPaths();

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params,
  draftMode,
}: GetStaticPropsContext<{ slug: string }>) {
  const props = await fetchResourceCategoryProps(params!.slug, draftMode);

  if (!props.page) {
    return {
      notFound: true,
    };
  }

  return { props };
}

export default function ResourceCategory(props: ResourceCategoryProps) {
  const data = props.page;

  return (
    <SearchableListing
      filters={`category:${data.slug}`}
      indexName={INDEX_MAP.RESOURCES}
      headline={data.pageTitle}
      description={data.description}
      searchInputPlaceholder="Search"
      classNames={{
        list: 'grid grid-cols-12 gap-x-20 gap-y-40',
        item: 'col-span-full m:col-span-6',
      }}
      preListingComponent={() => (
        <Headline
          value={data.title}
          as="h3"
          variant={3}
          className="mb-20 m:mb-50"
        />
      )}
      sidebarComponent={() => <ListingFilters filters={data.filters} />}
      hitComponent={({ hit }) => (
        <ResourceHit
          hit={hit}
          mediaSizes={['100vw', { '600px': '50vw', l: '33vw' }]}
        />
      )}
    />
  );
}
